module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1400.a568d3c4.svg";